module.exports = __webpack_public_path__ + "img/img2-4.b950f013.png";